/* bai-langue : drapeaux dans le selecteur de langue + conservation de la langue sur les liens ecrits en dur.
   Sans JavaScript, le selecteur garde ses libelles texte. Les drapeaux sont des SVG en ligne
   (les emojis drapeaux ne s'affichent pas sous Windows). */
(function(){
  "use strict";
  function bandes(c,vertical){
    var o="";
    for(var i=0;i<3;i++){
      o+=vertical
        ?'<rect x="'+(i*10)+'" width="10" height="20" fill="'+c[i]+'"/>'
        :'<rect y="'+(i*6.67)+'" width="30" height="6.67" fill="'+c[i]+'"/>';
    }
    return o;
  }
  var FLAGS={
    gb:'<rect width="30" height="20" fill="#012169"/>'
      +'<path d="M0 0l30 20M30 0L0 20" stroke="#fff" stroke-width="4"/>'
      +'<path d="M0 0l30 20M30 0L0 20" stroke="#C8102E" stroke-width="1.6"/>'
      +'<path d="M15 0v20M0 10h30" stroke="#fff" stroke-width="6"/>'
      +'<path d="M15 0v20M0 10h30" stroke="#C8102E" stroke-width="3.6"/>',
    de:bandes(["#000","#DD0000","#FFCE00"],false),
    nl:bandes(["#AE1C28","#fff","#21468B"],false),
    fr:bandes(["#0055A4","#fff","#EF4135"],true),
    it:bandes(["#009246","#fff","#CE2B37"],true),
    pl:'<rect width="30" height="10" fill="#fff"/><rect y="10" width="30" height="10" fill="#DC143C"/>',
    es:'<rect width="30" height="20" fill="#AA151B"/><rect y="5" width="30" height="10" fill="#F1BF00"/>'
  };
  var ALIAS={en:"gb"};
  function svg(code){
    var k=String(code||"").toLowerCase().slice(0,2);
    k=ALIAS[k]||k;
    if(!FLAGS[k])return null;
    var s=document.createElement("span");
    s.innerHTML='<svg class="bai-flag" width="24" height="16" viewBox="0 0 30 20" aria-hidden="true" focusable="false">'+FLAGS[k]+'</svg>';
    return s.firstChild;
  }
  function nom(el){var t=document.createElement("span");t.className="vh";t.textContent=el;return t}

  var btn=document.querySelector("[data-bai-lang]");
  if(btn){
    var f=svg(document.documentElement.lang);
    if(f){
      Array.prototype.slice.call(btn.childNodes).forEach(function(n){n.nodeType===3&&btn.removeChild(n)});
      btn.insertBefore(f,btn.firstChild);
    }
  }
  Array.prototype.forEach.call(document.querySelectorAll(".hdr-lang-menu button[name=language_code]"),function(b){
    var f=svg(b.value);
    if(!f)return;
    var libelle=b.textContent.trim();
    b.textContent="";
    b.appendChild(f);
    b.appendChild(nom(libelle));
    b.title=libelle;
  });

  /* Conserve la langue choisie : les liens internes ecrits en dur dans le theme
     ("/pages/...", "/collections/...") n'ont pas le prefixe de langue (/es, /de...).
     On le leur ajoute, a l'affichage puis au clic (liens crees par JavaScript). */
  var racine=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/";
  if(racine!=="/"){
    var base=racine.replace(/\/$/,"");
    var surAccueil=document.body.dataset.tpl==="index";
    var corrige=function(a){
      var h=a.getAttribute("href");
      if(!h||h.charAt(0)!=="/"||h.charAt(1)==="/")return;
      if(h===base||h.indexOf(base+"/")===0||h.indexOf(base+"?")===0||h.indexOf(base+"#")===0)return;
      if(h==="/checkout"||/^\/(cdn|checkout|apps|a|services)\//.test(h))return;
      if(h.indexOf("/#")===0){
        var id=h.slice(2);
        if(surAccueil||(id&&document.getElementById(id)))return;
      }
      a.setAttribute("href",base+h);
    };
    Array.prototype.forEach.call(document.querySelectorAll('a[href^="/"]'),corrige);
    document.addEventListener("click",function(e){
      var a=e.target.closest&&e.target.closest("a[href]");
      a&&corrige(a);
    },true);
  }
})();
